import { render, staticRenderFns } from "./LandingpageFreelancer.vue?vue&type=template&id=955af268"
import script from "./LandingpageFreelancer.vue?vue&type=script&lang=ts"
export * from "./LandingpageFreelancer.vue?vue&type=script&lang=ts"
import style0 from "./LandingpageFreelancer.vue?vue&type=style&index=0&id=955af268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports